// removed by extract-text-webpack-plugin
module.exports = {"success-text":"_3xjl-_jKTdw_ZFl5L3XRe9_0","failure-text":"Nhdc4MFcLra4n9qu8LmZG_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-471f3364","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/config/group/netdevice/components/DeviceAccountView.vue
// module id = dM2W
// module chunks = 75